import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { getToken } from "../auth/token";
import AuthPageShell from "../components/AuthPageShell";

const RAW_API_BASE = process.env.REACT_APP_API_URL || "";
const API_BASE = RAW_API_BASE.replace(/\/+$/, "").replace(/\/api$/, "");

export default function Register() {
    const { isAuthenticated, ready } = useAuth();
    const [email, setEmail] = useState("");
    const [nickname, setNickname] = useState("");
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("error");
    const [isSuccess, setIsSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    function extractErrorMessage(data, fallback) {
        if (!data) {
            return fallback;
        }

        if (Array.isArray(data.errors) && data.errors.length > 0) {
            return data.errors.join(", ");
        }

        if (typeof data.errors === "string" && data.errors.trim() !== "") {
            return data.errors;
        }

        if (typeof data.error === "string" && data.error.trim() !== "") {
            return data.error;
        }

        if (typeof data.message === "string" && data.message.trim() !== "") {
            return data.message;
        }

        return fallback;
    }

    if (!ready && getToken()) {
        return (
            <AuthPageShell>
                <p className="cms-page-loading">Загрузка...</p>
            </AuthPageShell>
        );
    }
    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    async function onSubmit(e) {
        e.preventDefault();
        setMessage("");
        setMessageType("error");
        setIsSuccess(false);
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/api/register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({ email, nickname, password }),
            });

            const data = await res.json().catch(() => null);
            if (!res.ok) {
                setMessage(extractErrorMessage(data, "Ошибка регистрации"));
                return;
            }

            if (data.status !== "email_confirmation_sent") {
                setMessage("Неожиданный ответ сервера при регистрации");
                return;
            }

            setIsSuccess(true);
            setMessageType("success");
            setMessage("Регистрация почти завершена. Мы отправили письмо со ссылкой для подтверждения email. Ссылка действительна 72 часа.");
            setPassword("");
        } catch {
            setMessage("Не удалось отправить запрос на регистрацию. Проверьте соединение и попробуйте снова.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <AuthPageShell>
            <h1 className="auth-page-title">Регистрация</h1>
            <form onSubmit={onSubmit} className="auth-form">
                <input
                    placeholder="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="ui-input"
                    required
                    disabled={loading || isSuccess}
                />
                <input
                    placeholder="Никнейм"
                    type="text"
                    value={nickname}
                    onChange={(e) => setNickname(e.target.value)}
                    className="ui-input"
                    required
                    disabled={loading || isSuccess}
                />
                <input
                    placeholder="Пароль (минимум 8 символов)"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="ui-input"
                    required
                    disabled={loading || isSuccess}
                />
                <button className="toolbar-btn" type="submit" disabled={loading || isSuccess}>
                    {loading ? "Регистрация..." : "Зарегистрироваться"}
                </button>
            </form>
            <div className="auth-links">
                <Link to="/login" className="btn-outline">Уже есть аккаунт</Link>
            </div>
            {message && (
                <p className={messageType === "success" ? "form-message--success" : "form-message"}>
                    {message}
                </p>
            )}
        </AuthPageShell>
    );
}
